<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ATx0SN/tc-custom/9781615953073.jpg?1733081734117" alt="This image is the cover for the book Deal to Die For, John Deal Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deal to Die For, John Deal Series
      </h1>
      <p class="bookDescription body article font2">
        <p>This suspenseful third John Deal crime thriller from Standiford finds the Miami building contractor tangling with Chinese gangsters who are trying to move in on a scheme hatched by two Hollywood porno magnates to create X-rated films for the huge mainland Chinese market. Deal already has troubles enough?his wife, Janice, has sunk into a deep depression over the serious burns she suffered in last year's Raw Deal, and a close friend has apparently committed suicide, shortly after she has told her film-star sister, Paige Nobleman, that Paige was adopted. Deal and his tenant/pal, ex-cop Vernon Driscoll, begin investigating Paige's birth and, eventually, the friend's death, following leads that take them directly into the porno scheme and the path of some deadly Chinese gang members. Standiford, an unusually fine thriller writer who has won the Frank O'Connor Award for Short Fiction and who directs the creative writing program at Florida International University, is at the top of his game here, displaying excellent pacing and a particular affinity for action scenes. The ongoing saga of John Deal remains especially intriguing above all, however, because its author drenches each volume in the ambiguities?sometimes rewarding, sometimes nightmarish?of real life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Les Standiford
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c80df3e